import React from 'react'
import {connect} from 'react-redux'
import { Route, Switch } from 'react-router'
import {Flex, Spinner} from '/app/src/component'
import {AutoMessageModel} from '/app/src/model/AutoMessage/'

import ListScreen from './ListScreen'
import ItemScreen from './ItemScreen'

class ClientChatRoute extends React.Component {

    componentDidMount() {
        if (!this.props.fetched) this.props.automessageReadDispatch()
    }

    render(){
        const {fetched, fetching} = this.props
        if (!fetched && fetching) return <Spinner/>
        return (
        <Flex grow>
            <Switch>
                <Route path='/clientChat/autoMessage/preview/:id?' component={ListScreen}/>
                <Route path='/clientChat/autoMessage/:action/:id?' component={ItemScreen}/>
                <Route path='/clientChat/autoMessage' component={ListScreen}/>
            </Switch>
        </Flex>
        )
    }
}

const {selector: automessageSelector, dispatcher: automessageRead} = AutoMessageModel.read()

function mapDispatchToProps(dispatch) {
    return {
        automessageReadDispatch: () => dispatch(automessageRead()),
        dispatch: dispatch //Keep this for legacy dispatch pattern. We will eventually map everything to the dispatcher.
    }
}

function mapStateToProps(state, props) {
    const netselector = automessageSelector(state).network
    return {
        fetched: netselector.get('fetched'),
        fetching: netselector.get('fetching')
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(ClientChatRoute);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/AutoMessage/index.js